import { StepProps, useAutoNavigate } from '@betterment/js-runtime';
import { Box, Button, H1, Icon, Text } from '@betterment/samba-react';

import { trackClick } from '../../features/track';
import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../Shared/urlBuilder';

export const SuccessStep: React.FC<StepProps> = ({ flowState }) => {
  const navigate = useAutoNavigate();

  return (
    <WorkflowLayout
      feature="advisor_network"
      pageTitle="Success"
      workflowTitle=""
      onClose={() => {
        trackClick({ name: 'CompleteFlow', flow: 'BAN' });
        void navigate(flowState.returnToPath);
      }}
      size="medium"
    >
      <Box css={{ display: 'grid', gap: 'space.200' }}>
        <Icon name="CheckmarkCircleFilled" color="icon.success" size="medium" />
        <H1 variant="pageTitle">You’re all set!</H1>
        <Text>Your call is scheduled. You’ll receive an email confirmation from one of our specialists.</Text>
        <Text>While you wait, explore more ways Betterment can support your financial goals.</Text>
        <Box css={{ display: 'flex', paddingTop: 'space.200', gap: 'space.200' }}>
          <Button
            onClick={() => {
              trackClick({ name: 'CompleteFlow', flow: 'BAN' });
              void navigate(flowState.returnToPath);
            }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              trackClick({ name: 'ExploreAccountOptions', flow: 'BAN' });
              void navigate(urlBuilder.appAddGoalFlowsNew.absolute());
            }}
            variant="solidSecondary"
          >
            Explore account options
          </Button>
        </Box>
      </Box>
    </WorkflowLayout>
  );
};
